import { createAction, createSlice } from '@reduxjs/toolkit';

import initState from '../../../domain/entities/stepper';

/**
 * Acá deberían de ir las acciones que no van a interactuar con el store
 * directamente. De preferencia son las acciones que se comunicarán con la saga
 */
const fetchStepper = createAction('fetchStepper');

/**
 * Acá deberían de ir las acciones que interecúan con el store directamente.
 */
function fetchStepperSuccess(state, action) {
  const { posicion } = action.payload;
  state.menuPosicion = posicion;
}

function fetchStepperFailed(state) {
  state.menuPosicion = null;
}

/**
 * Conexión
 */
const stepperReducer = createSlice({
  name: 'stepper',
  initialState: initState,
  reducers: {
    fetchStepperSuccess,
    fetchStepperFailed,
  },
});

export const stepperAction = {
  ...stepperReducer.actions,
  fetchStepper,
};

export default stepperReducer.reducer;
